import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import { UserProfilePicture } from '../../services/UserProfilePicture';
// import healixImage from '../../assets/Healix/Group 165112.png';
import healixImage from '../../assets/Healix/healix animated_optimised.svg';
import healixGreetingImage from '../../assets/Healix/Group 165099.png';
import botChatImage from '../../assets/Healix/Group 165124.png';
import DatabaseService from "../../services/DatabaseService";
import { Box, CircularProgress, Typography, Card, CardContent, CardMedia, Divider, Chip, alpha, useTheme, Button, Avatar } from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Person3 from '@mui/icons-material/Person3';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Product } from '../../types';
import { useCart } from '../../contexts/CartContext';
import { ProductCard } from '../ProductCard/ProductCard';
import jsPDF from 'jspdf';
import TypewriterMessage from '../../utils/TypewriterMessage';
import ReactMarkdown from 'react-markdown';
// Removed ChatBotSkinCare popup embedding; logic now runs inline with Healix design

// TypeScript interfaces from ChatBotSkinCare
interface Option {
  id: string;
  text: string;
  nextQuestion?: string;
  recommendations?: string[];
  usageTime?: string;
}

interface Question {
  id: string;
  question: string;
  options: Option[];
}

interface ChatbotData {
  questions: Question[];
}

interface TreeInfo {
  id: string;
  name: string;
  field_name: string;
  description?: string;
}

interface TreeSequence {
  id: string;
  name: string;
  trees: TreeInfo[];
}

interface ConversationHistoryItem {
  questionId: string;
  questionText: string;
  options: Option[];
  chosenOptionId: string;
  questionDate: string;
  withHeader: boolean;
  treeId?: string;
  treeName?: string;
  isHidden?: boolean;
}

interface ConversationItem {
  questionId: string;
  responseId: string | null;
}

// Props interface matching ChatBotSkinCare
interface ChatbotProps {
  chatbotData?: ChatbotData;
  finalizeChatbotStep?: (lastQuestionId: string | "", lastChosenOption: Option | undefined) => void;
  multiTreeMode?: boolean;
  treeSequence?: TreeSequence;
  onTreeComplete?: (treeId: string, responses: ConversationHistoryItem[]) => void;
  onAllTreesComplete?: (allResponses: ConversationHistoryItem[]) => void;
  demographicsOptions?: Record<string, string>;
  onDemographicsSubmit?: (ageGroup: string, gender: string, exactAge?: number) => void;
  onRoutineTimeSubmit?: (time: 'day' | 'night') => void;
  routineTime?: 'day' | 'night' | null;
  requestedTreeIndex?: number;
}

// Extended props for HealixBot wrapper
interface HealixBotProps extends ChatbotProps {
  treeDiagnosisToShow?: { treeName: string; diagnosis: any } | null;
  finalResultToShow?: { synthesis: any; recommendations: string[]; diagnoses: any[]; deduplicationData?: any } | null;
  onDiagnosisDisplayed?: () => void;
  onFinalResultDisplayed?: () => void;
}

const isAuthenticated = () => {
  return !!localStorage.getItem("userEmail");
};

const getCustomStartingMessages = (): string[] => {
  if (isAuthenticated()) {
    return [
      "Hello!",
      "I'm HEALIX , TACHAFY's chatbot.",
      "I'm gonna ask you some questions."
    ];
  } else {
    return [
      "Welcome!",
      "I'm HEALIX ,your holistic companion powered by TACHAFY.",
      "Here, beauty is more than what we see on the surface. It’s the harmony between your skin, your body, and your mind.",
      "Together, we’ll go through three steps:",
      "✨ Skin (Dermatology)",
      "✨ Body (Nutrition)",
      "✨ Mind (Psychology & Wellbeing)",
      "At the end, you’ll receive one complete diagnosis and a personalized plan to support your journey to balance and radiance.",
      "Shall we begin?”"
    ];
  }
};

const customStartingMessage: string[] = getCustomStartingMessages();

const customEndingMessage: string[] = [
  "Thank you for answering all of the questions!",
  "We appreciate your time and responses.",
  "Next, you will scan your face, and the AI will analyze your answers along with the facial scan to provide you with an accurate skin diagnosis"
];

// Personalized messages for each tree in multi-tree mode
const treeStartMessages: Record<number, string[]> = {
  0: [
    "Thank you for trusting me 💙,Your photo stays 100% confidential, analyzed only by Healix AI, never shared.",
    "Now, let's complete your skin profile.",
    "Your photo gives us scientific data, but your own experience matters too.",
    "I'll ask you a few quick questions , there are no right or wrong answers."
  ],
  1: [
    "What we eat and drink plays a direct role in energy, hormones, and even skin glow.",
    "I'll ask you a few short questions to better understand your nutrition and habits."
  ],
  2: [
    "The last step is about your inner balance.",
    "Stress, sleep, and emotions influence hormones, nutrition, and the way skin looks.",
    "I'll ask you a few gentle questions , no judgment, just to understand how you feel."
  ]
};

const treeFinishMessages: Record<number, string[]> = {
  0: [
    "Perfect 🌸. Your skin data is now saved, and your responses are being analyzed.",
    "Soon, we'll bring it together with your nutrition and wellbeing for a full picture."
  ],
  1: [
    "Thank you 🌿. Your nutrition profile is saved, and your responses are being analyzed.",
    "We're now closer to seeing the whole picture."
  ],
  2: [
    "Thank you 💎. Your wellbeing profile is saved, and your responses are being analyzed.",
    "We now have the three dimensions: skin, body, and mind."
  ]
};

// Helper function to render diagnosis cards
// Diagnosis Card
// const renderDiagnosisCard = (data: any) => {
//   const { treeName, diagnosis } = data;

//   return (
//     <Card
//       sx={{
//        background: '#F4F2EE',
//         border: '2px  #C37559',
//         borderRadius: '18px',
//         boxShadow: '0 6px 18px rgba(195, 117, 89, 0.15)',
//         mb: 2,
//         overflow: 'visible',
//       }}
//     >
//       <CardContent sx={{ p: 3 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//           <Box
//             sx={{
//               width: 46,
//               height: 46,
//               borderRadius: '50%',
//               background: '#C37559',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mr: 2,
//             }}
//           >
//             <Typography
//               sx={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}
//             >
//               {treeName.charAt(0)}
//             </Typography>
//           </Box>
//           <Box>
//             <Typography
//               sx={{
//                 fontFamily: 'Lato, sans-serif',
//                 fontWeight: 700,
//                 fontSize: '18px',
//                 color: '#131B5C',
//                 mb: 0.5,
//               }}
//             >
//               {treeName} Assessment
//             </Typography>
//             <Chip
//               label="Diagnosis Complete"
//               size="small"
//               sx={{
//                 backgroundColor: '#C37559',
//                 color: 'white',
//                 fontSize: '12px',
//                 fontWeight: 600,
//               }}
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 2, borderColor: 'rgba(195, 117, 89, 0.3)' }} />

//         <Typography
//           sx={{
//             fontFamily: 'Lato, sans-serif',
//             fontWeight: 700,
//             fontSize: '16px',
//             color: '#131B5C',
//             mb: 1,
//           }}
//         >
//           {diagnosis.name}
//         </Typography>

//         {diagnosis.description && (
//           <Typography
//             sx={{
//               fontFamily: 'Lato, sans-serif',
//               fontWeight: 400,
//               fontSize: '14px',
//               color: '#131B5C',
//               lineHeight: 1.6,
//             }}
//           >
//             {diagnosis.description}
//           </Typography>
//         )}
//       </CardContent>
//     </Card>
//   );
// };

// Final Synthesis Card
const renderFinalSynthesis = (data: any) => {
  const { synthesis } = data;

  return (
    <Card
      sx={{
       background: '#F4F2EE',
        // border: '2px solid #131B5C',
        borderRadius: '18px',
        
        mb: 2,
        overflow: 'visible',
      }}
    >
      <CardContent sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: '#131B5C',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2,
            }}
          >
            <Typography
              sx={{ color: 'white', fontSize: '28px', fontWeight: 'bold' }}
            >
              📋
            </Typography>
          </Box>
          <Typography
            sx={{
              fontFamily: 'Playfair Display, serif',
              fontWeight: 700,
              fontSize: '22px',
              color: '#131B5C',
              mb: 1,
            }}
          >
            Complete Health Assessment
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Lato, sans-serif',
              fontWeight: 600,
              fontSize: '14px',
              color: '#C37559',
              mb: 3,
            }}
          >
            Your Personalized Health Report
          </Typography>
        </Box>

        {synthesis.brief_resume && (
          <Box sx={{ mb: 3 }}>
            <Typography
              sx={{
                fontFamily: 'Lato, sans-serif',
                fontWeight: 700,
                fontSize: '16px',
                color: '#131B5C',
                mb: 1,
              }}
            >
              Brief Resume
            </Typography>
            <ReactMarkdown
              components={{
                p: ({ children }) => <Typography sx={{ fontFamily: 'Lato, sans-serif', fontWeight: 400, fontSize: '14px', color: '#131B5C', lineHeight: 1.6, pl: 3 }}>{children}</Typography>,
                strong: ({ children }) => <Typography component="span" sx={{ fontWeight: 700, color: '#C37559' }}>{children}</Typography>,
                ul: ({ children }) => <Box sx={{ pl: 5, mb: 2 }}>{children}</Box>,
                li: ({ children }) => <Typography sx={{ fontFamily: 'Lato, sans-serif', fontWeight: 400, fontSize: '14px', color: '#131B5C', lineHeight: 1.6, mb: 0.5 }}>{children}</Typography>,
              }}
            >
              {synthesis.brief_resume}
            </ReactMarkdown>
          </Box>
        )}

        <Typography
          sx={{
            fontFamily: 'Lato, sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            color: '#717B61',
            textAlign: 'center',
            mt: 2,
          }}
        >
          For more details, please download the full report below.
        </Typography>

      </CardContent>
    </Card>
  );
};


// Helper to generate PDF report from synthesis (reused by download message)
const generateSynthesisPdf = (synthesis: any) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  let yPosition = 30;

  doc.setFontSize(20);
  doc.setFont('times', 'bold');
  doc.setTextColor(19, 27, 92);
  doc.text('Complete Health Assessment Report', pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 20;

  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text(`Generated on: ${new Date().toLocaleString()}`, margin, yPosition);
  yPosition += 20;

  const addSection = (title: string, content: string) => {
    if (!content) return;
    doc.setFontSize(16);
    doc.setFont('times', 'bold');
    doc.setTextColor(195, 117, 89);
    doc.text(title, margin, yPosition);
    yPosition += 10;
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(19, 27, 92);
    const lines = doc.splitTextToSize(content, pageWidth - 2 * margin);
    doc.text(lines, margin, yPosition);
    yPosition += lines.length * 6 + 10;
    if (yPosition > 250) {
      doc.addPage();
      yPosition = 30;
    }
  };

  if (synthesis?.what_we_found) addSection('What We Found:', synthesis.what_we_found);
  if (synthesis?.skin_analysis) addSection('Skin Analysis:', synthesis.skin_analysis);
  if (synthesis?.nutrition_insights) addSection('Nutrition Insights:', synthesis.nutrition_insights);
  if (synthesis?.wellbeing_profile) addSection('Wellbeing Profile:', synthesis.wellbeing_profile);
  if (synthesis?.why_this_matters) addSection('Why This Matters:', synthesis.why_this_matters);
  if (synthesis?.root_causes) addSection('Root Causes:', synthesis.root_causes);
  if (synthesis?.healing_plan) addSection('Healing Plan:', synthesis.healing_plan);
  if (synthesis?.next_steps) addSection('Next Steps:', synthesis.next_steps);
  if (synthesis?.brief_resume) addSection('Brief Resume:', synthesis.brief_resume);

  doc.save('health-assessment-report.pdf');
};

// React component to render product recommendations
const ProductRecommendations: React.FC<{data: any, addToCart: any}> = ({ data, addToCart }) => {
  const { recommendations, deduplicationData } = data;
  const [products, setProducts] = useState<Product[]>([]);
  const [dayProducts, setDayProducts] = useState<Product[]>([]);
  const [nightProducts, setNightProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [expandedProducts, setExpandedProducts] = useState<Set<string>>(new Set());

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        let filteredProducts: Product[] = [];
        
        // If we have deduplication data, use primary products from it
        if (deduplicationData && deduplicationData.primary_products && deduplicationData.primary_products.length > 0) {
          console.log('📦 Using deduplicated products from backend');
          // Map backend product format to frontend Product type
          filteredProducts = deduplicationData.primary_products.map((p: any) => ({
            id: p.id,
            name: p.name,
            description: p.description,
            price: p.price,
            category: p.category,
            composant_chimique: p.composant_chimique,
            numberInStock: p.stock_number,
            inStock: p.in_stock,
            imageData: p.image_data,
            imageMimeType: p.image_mime_type
          }));
        } else {
          // Fallback: fetch all products and filter by recommendations
          console.log('📦 Fetching products from database (no deduplication data)');
          const allProducts = await DatabaseService.getProducts();
          filteredProducts = allProducts.filter(product =>
            recommendations.includes(product.id)
          );
        }
        
        setProducts(filteredProducts);
        
        // Categorize products by day/night
        const day: Product[] = [];
        const night: Product[] = [];
        
        filteredProducts.forEach(product => {
          const ingredientsLower = (product.composant_chimique || '').toLowerCase();
          const nameLower = product.name.toLowerCase();
          
          // Night indicators (photosensitive ingredients)
          const nightIndicators = ['retinol', 'retinyl', 'vitamin a', 'tretinoin', 'adapalene', 'melatonin'];
          const isNight = nightIndicators.some(indicator => 
            ingredientsLower.includes(indicator) || nameLower.includes(indicator)
          );
          
          if (isNight) {
            night.push(product);
          } else {
            // Day indicators or default to day
            day.push(product);
          }
        });
        
        setDayProducts(day);
        setNightProducts(night);
        console.log(`🌞 Day products: ${day.length} | 🌙 Night products: ${night.length}`);
      } catch (error) {
        console.error('Error fetching products:', error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [recommendations, deduplicationData]);

  const toggleSimilarProducts = (productId: string) => {
    setExpandedProducts(prev => {
      const newSet = new Set(prev);
      if (newSet.has(productId)) {
        newSet.delete(productId);
      } else {
        newSet.add(productId);
      }
      return newSet;
    });
  };

  const getSimilarProducts = (productId: string): Product[] => {
    if (!deduplicationData || !deduplicationData.similar_groups || !deduplicationData.similar_groups[productId]) {
      return [];
    }
    
    const similarGroup = deduplicationData.similar_groups[productId];
    if (!similarGroup.products || similarGroup.products.length === 0) {
      return [];
    }
    
    // Map backend product format to frontend Product type
    return similarGroup.products.map((p: any) => ({
      id: p.id,
      name: p.name,
      description: p.description,
      price: p.price,
      category: p.category,
      composant_chimique: p.composant_chimique,
      numberInStock: p.stock_number,
      inStock: p.in_stock,
      imageData: p.image_data,
      imageMimeType: p.image_mime_type
    }));
  };

  const getSharedIngredients = (productId: string): string => {
    if (!deduplicationData || !deduplicationData.similar_groups || !deduplicationData.similar_groups[productId]) {
      return '';
    }
    
    const similarGroup = deduplicationData.similar_groups[productId];
    return similarGroup.shared_agents ? similarGroup.shared_agents.join(', ') : '';
  };

 if (loading) {
  return (
    <Card
      sx={{
       background: 'transparent',
        borderRadius: '16px',
        p: 3,
        textAlign: 'center',
      }}
    >
      <CircularProgress size={24} sx={{ color: '#C37559' }} />
                      <Typography
                        sx={{
                          mt: 1,
                          fontFamily: 'Lato, sans-serif',
                          fontSize: '16px',
                          color: '#131B5C',
                        }}
                      >
                        Loading recommendations...
                      </Typography>
    </Card>
  );
}

return (
  <Box
    sx={{
      background: 'transparent',
      width: '100%',
    }}
  >
    {/* Day Products Section */}
    {dayProducts.length > 0 && (
      <Box sx={{ mb: 4 }}>
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: { xs: '20px', sm: '24px' },
            color: '#FFB800',
            mb: 3,
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            letterSpacing: '0.5px'
          }}
        >
          🌞 Morning Routine Products
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(200px, 280px))',
              md: 'repeat(3, minmax(200px, 280px))',
            },
            gap: 2,
            justifyContent: 'flex-start',
            overflow: 'visible',
            maxWidth: '100%',
          }}
        >
          {dayProducts.map((product) => {
            const similarProducts = getSimilarProducts(product.id);
            const sharedIngredients = getSharedIngredients(product.id);
            const isExpanded = expandedProducts.has(product.id);
            
            return (
              <Box key={product.id}>
                <ProductCard
                  id={product.id}
                  name={product.name}
                  brand={product.name}
                  variant={product.category || ''}
                  price={product.price}
                  description={product.description}
                  category={product.category}
                  image={product.imageData}
                  imageData={product.imageData}
                  inStock={product.inStock}
                  setShowPartnerDialog={() => {}}
                  partner_id={product.partner_id}
                  partner_info={product.partner_info}
                />
                
                {/* Similar Products Button */}
                {similarProducts.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    <Button
                      onClick={() => toggleSimilarProducts(product.id)}
                      sx={{
                        width: '100%',
                        textTransform: 'none',
                        color: '#C37559',
                        borderColor: '#C37559',
                        '&:hover': {
                          borderColor: '#A85D47',
                          backgroundColor: 'rgba(195, 117, 89, 0.04)'
                        }
                      }}
                      variant="outlined"
                      size="small"
                    >
                      {isExpanded ? '▲' : '▼'} View Similar Products ({similarProducts.length})
                    </Button>
                    
                    {/* Expanded Similar Products */}
                    {isExpanded && (
                      <Box sx={{ mt: 2, pl: 2, borderLeft: '3px solid #C37559' }}>
                        <Typography sx={{ fontSize: '12px', color: '#666', mb: 1, fontStyle: 'italic' }}>
                          Similar products with: {sharedIngredients}
                        </Typography>
                        {similarProducts.map((similarProduct) => (
                          <Box key={similarProduct.id} sx={{ mb: 2 }}>
                            <ProductCard
                              id={similarProduct.id}
                              name={similarProduct.name}
                              brand={similarProduct.name}
                              variant={similarProduct.category || ''}
                              price={similarProduct.price}
                              description={similarProduct.description}
                              category={similarProduct.category}
                              image={similarProduct.imageData}
                              imageData={similarProduct.imageData}
                              inStock={similarProduct.inStock}
                              setShowPartnerDialog={() => {}}
                              partner_id={similarProduct.partner_id}
                              partner_info={similarProduct.partner_info}
                            />
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    )}

    {/* Night Products Section */}
    {nightProducts.length > 0 && (
      <Box sx={{ mb: 2 }}>
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: { xs: '20px', sm: '24px' },
            color: '#5B4FFF',
            mb: 3,
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            letterSpacing: '0.5px'
          }}
        >
          🌙 Evening Routine Products
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(200px, 280px))',
              md: 'repeat(3, minmax(200px, 280px))',
            },
            gap: 2,
            justifyContent: 'flex-start',
            overflow: 'visible',
            maxWidth: '100%',
          }}
        >
          {nightProducts.map((product) => {
            const similarProducts = getSimilarProducts(product.id);
            const sharedIngredients = getSharedIngredients(product.id);
            const isExpanded = expandedProducts.has(product.id);
            
            return (
              <Box key={product.id}>
                <ProductCard
                  id={product.id}
                  name={product.name}
                  brand={product.name}
                  variant={product.category || ''}
                  price={product.price}
                  description={product.description}
                  category={product.category}
                  image={product.imageData}
                  imageData={product.imageData}
                  inStock={product.inStock}
                  setShowPartnerDialog={() => {}}
                  partner_id={product.partner_id}
                  partner_info={product.partner_info}
                />
                
                {/* Similar Products Button */}
                {similarProducts.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    <Button
                      onClick={() => toggleSimilarProducts(product.id)}
                      sx={{
                        width: '100%',
                        textTransform: 'none',
                        color: '#C37559',
                        borderColor: '#C37559',
                        '&:hover': {
                          borderColor: '#A85D47',
                          backgroundColor: 'rgba(195, 117, 89, 0.04)'
                        }
                      }}
                      variant="outlined"
                      size="small"
                    >
                      {isExpanded ? '▲' : '▼'} View Similar Products ({similarProducts.length})
                    </Button>
                    
                    {/* Expanded Similar Products */}
                    {isExpanded && (
                      <Box sx={{ mt: 2, pl: 2, borderLeft: '3px solid #C37559' }}>
                        <Typography sx={{ fontSize: '12px', color: '#666', mb: 1, fontStyle: 'italic' }}>
                          Similar products with: {sharedIngredients}
                        </Typography>
                        {similarProducts.map((similarProduct) => (
                          <Box key={similarProduct.id} sx={{ mb: 2 }}>
                            <ProductCard
                              id={similarProduct.id}
                              name={similarProduct.name}
                              brand={similarProduct.name}
                              variant={similarProduct.category || ''}
                              price={similarProduct.price}
                              description={similarProduct.description}
                              category={similarProduct.category}
                              image={similarProduct.imageData}
                              imageData={similarProduct.imageData}
                              inStock={similarProduct.inStock}
                              setShowPartnerDialog={() => {}}
                              partner_id={similarProduct.partner_id}
                              partner_info={similarProduct.partner_info}
                            />
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    )}

    {/* Fallback if no products */}
    {products.length === 0 && !loading && (
      <Typography
        sx={{
          fontFamily: 'Lato, sans-serif',
          fontSize: '16px',
          color: '#131B5C',
          textAlign: 'center',
          py: 3
        }}
      >
        No products available at this time.
      </Typography>
    )}
  </Box>
);

};

const getCurrentDate = () => {
  const date = new Date();
  return date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    day: '2-digit',
    month: 'short'
  }).replace(',', '');
};

const HealixBot: React.FC<HealixBotProps> = ({
  chatbotData,
  finalizeChatbotStep,
  multiTreeMode = false,
  treeSequence,
  onTreeComplete,
  onAllTreesComplete,
  demographicsOptions,
  onDemographicsSubmit,
  requestedTreeIndex,
  treeDiagnosisToShow,
  finalResultToShow,
  onDiagnosisDisplayed,
  onFinalResultDisplayed
}) => {
  const navigate = useNavigate();
  const { isAuthenticated: authContextAuthenticated } = useAuth();
  const { addToCart } = useCart();
  const theme = useTheme();
  const [currentScreen, setCurrentScreen] = useState<'welcome' | 'greeting' | 'conversation'>(() => {
    if (isAuthenticated()) {
      return 'greeting';
    } else {
      return 'welcome';
    }
  });
  
  // State for floating Healix animation
  const [showFloatingHealix, setShowFloatingHealix] = useState(false);
  const [healixReaction, setHealixReaction] = useState<'wave' | 'excited' | 'thinking' | 'idle' | 'encourage' | 'celebrate'>('idle');
  const [showParticles, setShowParticles] = useState(false);
  const [motivationalMessage, setMotivationalMessage] = useState<string>('');
  const floatingHealixRef = useRef<HTMLDivElement>(null);
  
  // Motivational messages pool
  const motivationalMessages = {
    wave: [
      "Hey there! 👋",
      "Welcome back! 💙",
      "I'm here for you! 🌟",
      "Ready to help! ✨"
    ],
    excited: [
      "Great choice! ✨",
      "You're doing amazing! 🌟",
      "Perfect! Keep going! 💪",
      "Awesome progress! 🎉",
      "You're on fire! 🔥"
    ],
    thinking: [
      "Let me think... 🤔",
      "Analyzing... 💭",
      "Processing... ⚡",
      "One moment... 🔍"
    ],
    encourage: [
      "You've got this! 💪",
      "Believe in yourself! ⭐",
      "You're stronger than you think! 🌈",
      "Every step counts! 🌸",
      "Keep shining! ✨",
      "Your journey matters! 💎",
      "You're making progress! 🌱",
      "Stay positive! 🌞"
    ],
    celebrate: [
      "Well done! 🎉",
      "You're incredible! 🌟",
      "Amazing work! 🏆",
      "Proud of you! 💖",
      "You're a star! ⭐",
      "Fantastic! 🎊"
    ]
  };
  
  // Get random message from category
  const getRandomMessage = (category: keyof typeof motivationalMessages) => {
    const messages = motivationalMessages[category];
    return messages[Math.floor(Math.random() * messages.length)];
  };
  
  // Create particles effect
  const createParticles = () => {
    setShowParticles(true);
    setTimeout(() => setShowParticles(false), 500);
  };
  
  // Helper function to check if a message is a special type (JSON data)
  const isSpecialMessage = (messageText: string) => {
    try {
      const parsed = JSON.parse(messageText);
      return parsed && typeof parsed === 'object' && parsed.type;
    } catch {
      return false;
    }
  };

  // Helper function to render special message types
  const renderSpecialMessage = (messageText: string) => {
    try {
      const data = JSON.parse(messageText);
      switch (data.type) {
        // case 'diagnosis':
        //   return renderDiagnosisCard(data);
        case 'loading_dots':
          return (
            <Box sx={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: 0.5,
              py: 1
            }}>
              <Box 
                sx={{ 
                  width: 8, 
                  height: 8, 
                  borderRadius: '50%', 
                  backgroundColor: '#C37559',
                  animation: 'bounce 1.4s infinite ease-in-out both',
                  animationDelay: '-0.32s',
                  '@keyframes bounce': {
                    '0%, 80%, 100%': { transform: 'scale(0)' },
                    '40%': { transform: 'scale(1.0)' }
                  }
                }} 
              />
              <Box 
                sx={{ 
                  width: 8, 
                  height: 8, 
                  borderRadius: '50%', 
                  backgroundColor: '#C37559',
                  animation: 'bounce 1.4s infinite ease-in-out both',
                  animationDelay: '-0.16s',
                  '@keyframes bounce': {
                    '0%, 80%, 100%': { transform: 'scale(0)' },
                    '40%': { transform: 'scale(1.0)' }
                  }
                }} 
              />
              <Box 
                sx={{ 
                  width: 8, 
                  height: 8, 
                  borderRadius: '50%', 
                  backgroundColor: '#C37559',
                  animation: 'bounce 1.4s infinite ease-in-out both',
                  '@keyframes bounce': {
                    '0%, 80%, 100%': { transform: 'scale(0)' },
                    '40%': { transform: 'scale(1.0)' }
                  }
                }} 
              />
            </Box>
          );
        case 'final_synthesis':
          return renderFinalSynthesis(data);
        case 'product_recommendations':
          return <ProductRecommendations data={data} addToCart={addToCart} />;
        case 'download_report':
          return (
            <Box sx={{ textAlign: 'left' }}>
              <Box
                component="a"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  generateSynthesisPdf(data.synthesis);
                }}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1,
                  fontFamily: 'Lato, sans-serif',
                  fontWeight: 600,
                  fontSize: '16px',
                  color: '#717B61',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  '&:hover': {
                    color: '#5a6b4a',
                  },
                }}
              >
                <PictureAsPdfIcon sx={{ fontSize: '18px' }} />
                Download your full report
              </Box>
            </Box>
          );
        default:
          return messageText;
      }
    } catch {
      return messageText;
    }
  };
  const [conversationStarted, setConversationStarted] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>('');
  const [userAvatar, setUserAvatar] = useState<string>('');
  const [userGender, setUserGender] = useState<string>('');
  const chatWindowRef = useRef<HTMLDivElement>(null);

  // Multi-tree state
  const [currentTreeIndex, setCurrentTreeIndex] = useState<number>(0);
  const [currentTreeData, setCurrentTreeData] = useState<ChatbotData | null>(null);
  const [currentTreeInfo, setCurrentTreeInfo] = useState<TreeInfo | null>(null);
  const [allTreeResponses, setAllTreeResponses] = useState<ConversationHistoryItem[]>([]);
  const [isLoadingNextTree, setIsLoadingNextTree] = useState<boolean>(false);
  // Internal fallback sequence when no props are provided
  const [internalTreeSequence, setInternalTreeSequence] = useState<TreeSequence | undefined>(undefined);
  const effectiveTreeSequence = treeSequence || internalTreeSequence;
  // Popup removed; conversation runs inline
  
  // Conversation state
  const [currentQuestionId, setCurrentQuestionId] = useState<string>("");
  const [conversationHistory, setConversationHistory] = useState<ConversationHistoryItem[]>([]);
  const [isLoadingDiagnosisVisible, setIsLoadingDiagnosisVisible] = useState(false);
  const [hasRun, setHasRun] = useState(false);
  const [greetingsDone, setGreetingsDone] = useState(false);
  const [showFinalCTA, setShowFinalCTA] = useState<boolean>(false);
  const [completedTreeIndices, setCompletedTreeIndices] = useState<Set<number>>(new Set());
  const [isInFinalStep, setIsInFinalStep] = useState<boolean>(false);
  
  // Section transition popup state
  const [showTransitionPopup, setShowTransitionPopup] = useState<boolean>(false);
  const [transitionSection, setTransitionSection] = useState<{
    title: string;
    subtitle: string;
    icon: string;
  } | null>(null);
  
  // Demographics state - properly initialized based on mode
  const [showDemographics, setShowDemographics] = useState<boolean>(() => 
    multiTreeMode && !demographicsOptions
  );
  const [numericAge, setNumericAge] = useState<string>('');
  const [selectedAge, setSelectedAge] = useState<string>('');
  const [selectedGender, setSelectedGender] = useState<string>('');
  const [demographicsCompleted, setDemographicsCompleted] = useState<boolean>(() =>
    !multiTreeMode || !!demographicsOptions
  );

  // Age mapping function
  const mapAgeToRange = (age: number): string => {
    if (age < 18) return 'under18';
    if (age >= 18 && age <= 25) return '18-25';
    if (age > 25 && age <= 45) return '25-45';
    return 'over45';
  };

  // Update demographics state when demographicsOptions prop changes
  useEffect(() => {
    if (multiTreeMode && demographicsOptions) {
      // Demographics were provided from parent - hide selector and mark as completed
      setShowDemographics(false);
      setDemographicsCompleted(true);
    }
  }, [multiTreeMode, demographicsOptions]); // Only depend on props, not state
  
  // Debug logging (only on significant state changes)
  useEffect(() => {
    if (multiTreeMode) {
      console.log('🔍 ChatBot State:', {
        showDemographics,
        demographicsCompleted,
        hasRun,
        conversationHistoryLength: conversationHistory.length,
        demographicsOptions: demographicsOptions ? 'provided' : 'none'
      });
    }
  }, [multiTreeMode, showDemographics, demographicsCompleted, hasRun, conversationHistory.length, demographicsOptions]);

  // Determine active data (support internal multi-tree fallback) - MOVED BEFORE useEffects that use it
  const isMultiMode = multiTreeMode || !!effectiveTreeSequence;
  const activeData = isMultiMode ? currentTreeData : chatbotData;
  const currentQuestion = activeData?.questions.find(q => q.id === currentQuestionId);
  
  // Progress calculation
  const totalQuestions = activeData?.questions.length || 0;
  const currentStepName = currentTreeInfo?.field_name || "Assessment";
  const progressPercentage = totalQuestions > 0 ? Math.round(((conversationHistory.filter(h => h.chosenOptionId && !h.isHidden).length) / totalQuestions) * 100) : 0;

  // Fetch user info for HealixBot screens
  useEffect(() => {
    if (authContextAuthenticated) {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          setUserName(userInfo.utilisateur?.prenom || userInfo.prenom || '');
          
          const userId = userInfo?.utilisateur?.id || userInfo?.id || null;
          if (userId) {
            const fetchProfilePicture = async () => {
              try {
                const data = await UserProfilePicture.getProfilePicture(userId);
                if (data?.image_base64) {
                  setUserAvatar(data.image_base64);
                } else {
                  // No image returned, use empty string to trigger avatar display
                  setUserAvatar('');
                }
              } catch (error) {
                // Handle 404 or any error - use empty string to show avatar
                console.log("No profile picture found, using default avatar");
                setUserAvatar('');
              }
            };
          fetchProfilePicture();
        }

        setCurrentScreen('greeting');
        } catch (error) {
          console.error('Error parsing userInfo:', error);
        }
      }
    } else {
      setCurrentScreen('welcome');
    }
  }, [authContextAuthenticated]);
  
  // Show floating Healix when conversation starts
  useEffect(() => {
    if (currentScreen === 'conversation' && conversationHistory.length > 0) {
      const timer = setTimeout(() => {
        setShowFloatingHealix(true);
        setHealixReaction('wave');
        setMotivationalMessage(getRandomMessage('wave'));
        setTimeout(() => setHealixReaction('idle'), 1250);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [currentScreen, conversationHistory.length]);
  
  // Healix reacts when user answers questions
  useEffect(() => {
    const lastItem = conversationHistory[conversationHistory.length - 1];
    if (lastItem && lastItem.chosenOptionId) {
      // Alternate between excited and celebrate for variety
      const reactionType = Math.random() > 0.5 ? 'excited' : 'celebrate';
      setHealixReaction(reactionType);
      setMotivationalMessage(getRandomMessage(reactionType));
      createParticles();
      setTimeout(() => setHealixReaction('idle'), 2500);
    }
  }, [conversationHistory]);
  
  // Healix thinks when new questions appear
  useEffect(() => {
    if (currentQuestion && !greetingsDone) {
      setHealixReaction('thinking');
      setMotivationalMessage(getRandomMessage('thinking'));
      setTimeout(() => setHealixReaction('idle'), 900);
    }
  }, [currentQuestion]);
  
  // Random encouragement messages - show periodically
  useEffect(() => {
    if (currentScreen === 'conversation' && showFloatingHealix && healixReaction === 'idle') {
      const encourageInterval = setInterval(() => {
        // Randomly show encouragement (30% chance every 15 seconds)
        if (Math.random() < 0.3) {
          setHealixReaction('encourage');
          setMotivationalMessage(getRandomMessage('encourage'));
          setTimeout(() => setHealixReaction('idle'), 1500);
        }
      }, 15000); // Check every 15 seconds
      
      return () => clearInterval(encourageInterval);
    }
  }, [currentScreen, showFloatingHealix, healixReaction]);

  const handleSubscribeClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (!authContextAuthenticated) {
      // Redirect back to multi-tree survey after sign-in
      localStorage.setItem('postLoginRedirect', JSON.stringify({ from: 'HealixBot', target: '/healix-multi-tree-survey' }));
      navigate('/signIn');
    }
  };

  const showSectionTransition = (sectionTitle: string, sectionSubtitle: string, sectionIcon: string) => {
    setTransitionSection({
      title: sectionTitle,
      subtitle: sectionSubtitle,
      icon: sectionIcon
    });
    setShowTransitionPopup(true);
    
    // Auto-hide after 6 seconds for better user engagement
    setTimeout(() => {
      setShowTransitionPopup(false);
    }, 5000);
  };

  const handleStartConversation = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Start conversation inline with Healix design, using the same logic as ChatBotSkinCare
    const startInline = async () => {
      try {
        // If no props provided for trees, fetch default tree sequence to enable multi-tree flow
        if (!treeSequence && !internalTreeSequence) {
          const seq = await DatabaseService.getDefaultTreeSequence();
          const converted: TreeSequence = {
            id: seq.sequence.id,
            name: seq.sequence.name,
            trees: seq.trees.map((t: any) => ({
              id: t.id,
              name: t.name,
              field_name: t.field_name,
              description: t.description,
            })),
          };
          setInternalTreeSequence(converted);
        }
      } catch (e) {
        console.warn('Could not load default tree sequence; will try single-tree if provided.', e);
      } finally {
        // Move to conversation screen; the useEffect will initialize based on available data
        setConversationStarted(true);
        setCurrentScreen('conversation');
        // Force demographics first, then initialization resumes after completion
        setShowDemographics(true);
        setDemographicsCompleted(false);
      }
    };
    startInline();
  };

  // Typewriter effect
  const keyWordDelay = 30;
  const awaitingTimeForNextMessage = (text: string) => {
    // Special messages (JSON-rendered cards) should not wait based on length
    // to avoid long delays. Use a short fixed delay instead.
    if (isSpecialMessage(text)) {
      return 250;
    }
    // Increased delay: 30ms per char + 800ms base delay for better readability
    // Minimum 1.5 seconds for short messages, scales with length
    const calculatedDelay = keyWordDelay * text.length + 800;
    return Math.max(1500, calculatedDelay);
  };

  const chatbotCustomRespond = async (customId: string, messages: string[]) => {
    let isWithHeader = true;
    for (let i = 0; i < messages.length; i++) {
      const messageId = customId + Date.now() + '_' + i;
      
      setConversationHistory((prevHistory) => {
        const existingMessage = prevHistory.find(item => 
          item.questionText === messages[i] && item.questionId.startsWith(customId)
        );
        
        if (existingMessage) return prevHistory;

        const customConversationHistoryItem: ConversationHistoryItem = {
          questionId: messageId,
          questionText: messages[i],
          options: [],
          chosenOptionId: "",
          questionDate: getCurrentDate(),
          withHeader: isWithHeader
        };
        return [...prevHistory, customConversationHistoryItem];
      });
      
      // Wait briefly for the message to be rendered, then scroll
      await new Promise((resolve) => setTimeout(resolve, 100));
      
      // Trigger scroll to show the new message
      if (chatWindowRef.current) {
        chatWindowRef.current.scrollTo({
          top: chatWindowRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
      
      const awaitingTime = awaitingTimeForNextMessage(messages[i]);
      await new Promise((resolve) => setTimeout(resolve, awaitingTime));
      isWithHeader = false;
    }
  };

  // Initialize conversation: greetings → demographics (if needed) → loading → first tree/questions
  useEffect(() => {
    if (hasRun) return; // Prevent running again
    
    // Additional check: don't run if we already have conversation history
    if (conversationHistory.length > 0) return;
    
    // Only run when on conversation screen
    if (currentScreen !== 'conversation') return;
    
    // NEW: Don't start until demographics are completed (or not needed)
    if (!demographicsCompleted) return;
    
    setHasRun(true);

    const startConversation = async () => {
      if (multiTreeMode && effectiveTreeSequence) {
        // Multi-tree mode: Load first tree
        await initializeMultiTreeMode();
      } else {
        // Single tree mode: Start with greetings
        await chatbotCustomRespond("customStartingMessage", customStartingMessage);
        setGreetingsDone(true);
      }
    };
    startConversation();
  }, [multiTreeMode, effectiveTreeSequence, hasRun, conversationHistory.length, demographicsCompleted, currentScreen]); // Add demographicsCompleted dependency

  // Watch for parent-requested tree index changes
  useEffect(() => {
    if ((multiTreeMode || effectiveTreeSequence) && requestedTreeIndex !== undefined && requestedTreeIndex !== currentTreeIndex) {
      console.log(`🔄 Parent requested tree index ${requestedTreeIndex}, loading...`);
      loadTreeData(requestedTreeIndex);
    }
  }, [requestedTreeIndex]);

  // Multi-tree initialization
  const initializeMultiTreeMode = async (sequenceOverride?: TreeSequence) => {
    try {
      const seqToUse = sequenceOverride || effectiveTreeSequence;
      if (!seqToUse || !seqToUse.trees || seqToUse.trees.length === 0) {
        console.error('No trees in sequence');
        return;
      }

      const treesLength = seqToUse.trees.length;
      console.log(`🚀 Initializing multi-tree mode with ${treesLength} trees:`, seqToUse.trees.map(t => `${t.id} (${t.field_name})`));
      
      // Show initial greeting for multi-tree
      const multiTreeGreeting = [
        "Welcome!",
      "I'm HEALIX ,your holistic companion powered by TACHAFY.",
      "Here, beauty is more than what we see on the surface. It’s the harmony between your skin, your body, and your mind.",
      "Together, we’ll go through three steps:",
      "✨ Skin (Dermatology)",
      "✨ Body (Nutrition)",
      "✨ Mind (Psychology & Wellbeing)",
      "At the end, you’ll receive one complete diagnosis and a personalized plan to support your journey to balance and radiance.",
      "Shall we begin?"
      ];
      await chatbotCustomRespond("multiTreeGreeting", multiTreeGreeting);
      
      // Load first tree
      await loadTreeData(0, seqToUse);
    } catch (error) {
      console.error('Error initializing multi-tree mode:', error);
    }
  };

  // Load tree data - EXACT ChatBotSkinCare logic
  const loadTreeData = async (treeIndex: number, sequenceOverride?: TreeSequence) => {
    try {
      const seqToUse = sequenceOverride || effectiveTreeSequence;
      if (!seqToUse || treeIndex >= seqToUse.trees.length) {
        // All trees completed - this is handled by handleTreeCompletion, no need to call again
        console.log('🏁 All trees completed, no more trees to load');
        return;
      }

      // Show finish message of previous tree as transition message if not first tree
      if (treeIndex > 0) {
        const finishMessages = treeFinishMessages[treeIndex - 1];
        if (finishMessages) {
          await chatbotCustomRespond(`treeFinishTransition_${treeIndex - 1}`, finishMessages);
        }
        // Add a small delay before starting the next tree
        await new Promise(resolve => setTimeout(resolve, 400));
      }

      const tree = seqToUse.trees[treeIndex];
      console.log(`🌳 Loading tree ${treeIndex + 1}/${seqToUse.trees.length}: ${tree.id} (${tree.field_name})`);
      setCurrentTreeIndex(treeIndex);
      setCurrentTreeInfo(tree);
      setIsLoadingNextTree(true);

      // Use personalized start messages for each tree
      const personalizedStartMessages = treeStartMessages[treeIndex];
      if (personalizedStartMessages) {
        await chatbotCustomRespond(`treeStart_${treeIndex}`, personalizedStartMessages);
      } else {
        // Fallback to generic messages if no personalized message is found
        if (treeIndex > 0) {
          const transitionMessage = [
            `Great! Now we'll move to the next area.`,
            `Let's talk about ${tree.field_name}.`
          ];
          await chatbotCustomRespond("fieldTransition", transitionMessage);
        } else {
          const firstTreeMessage = [`Let's start with ${tree.field_name}.`];
          await chatbotCustomRespond("firstTree", firstTreeMessage);
        }
      }

      // Show section transition popup with motivating messages WHILE loading tree data
      const sectionTransitions: { [key: number]: { title: string, subtitle: string, icon: string } } = {
        0: { title: 'Your Radiance Begins Here', subtitle: 'Let\'s unlock your skin\'s natural beauty together', icon: '✨' },
        1: { title: 'Fuel Your Inner Glow', subtitle: 'Your body deserves the best nourishment', icon: '🌿' },
        2: { title: 'Embrace Your Well-Being', subtitle: 'True beauty blooms from inner harmony', icon: '💎' }
      };
      
      // Get transition for current tree, or use a default one
      const transition = sectionTransitions[treeIndex] || {
        title: `${tree.field_name}`,
        subtitle: 'Let\'s continue your wellness journey',
        icon: '🌟'
      };
      
      // Show popup and start loading tree data in parallel
      showSectionTransition(transition.title, transition.subtitle, transition.icon);
      
      // Load tree data while popup is visible
      const treeData = await DatabaseService.getQuestionsByTree(tree.id);
      
      // Wait for remaining popup time if tree loads quickly
      await new Promise(resolve => setTimeout(resolve, 1000));
      const convertedQuestions = treeData.questions.map(dbQ => ({
        id: dbQ.id,
        question: dbQ.question,
        options: dbQ.options.map(dbOpt => ({
          id: dbOpt.id || '',
          text: dbOpt.text,
          nextQuestion: dbOpt.nextQuestion,
          recommendations: dbOpt.recommendations
        }))
      }));
      setCurrentTreeData({ questions: convertedQuestions });
      
      if (demographicsOptions && demographicsOptions[tree.id]) {
        const rootQuestion = treeData.questions[0];
        if (rootQuestion) {
          const demographicOptionId = demographicsOptions[tree.id];
          const demographicOption = rootQuestion.options.find(opt => opt.id === demographicOptionId);
          
          if (demographicOption) {
            console.log(`🎯 Auto-answering demographic question for ${tree.id}:`, demographicOption.text);
            console.log(`✓ Adding to history as hidden, moving to next question`);
            
            // Add demographic question to history BUT mark as hidden
            // This keeps the response tracking logic intact while hiding from UI
            const demographicResponse: ConversationHistoryItem = {
              questionId: rootQuestion.id,
              questionText: rootQuestion.question,
              options: rootQuestion.options.map(opt => ({
                id: opt.id || '',
                text: opt.text,
                nextQuestion: opt.nextQuestion,
                recommendations: opt.recommendations
              })),
              chosenOptionId: demographicOptionId,
              questionDate: getCurrentDate(),
              withHeader: true,
              treeId: tree.id,
              treeName: tree.field_name,
              isHidden: true // Mark as hidden - won't display in UI
            };
            
            setConversationHistory(prev => [...prev, demographicResponse]);
            
            // Move to the next question after demographic
            if (demographicOption.nextQuestion) {
              setCurrentQuestionId(demographicOption.nextQuestion);
            } else {
              console.warn(`⚠️ Demographic option has no nextQuestion for ${tree.id}`);
              setCurrentQuestionId(convertedQuestions[0]?.id || "");
            }
          } else {
            console.warn(`⚠️ Demographic option not found for ${tree.id}, showing root question`);
            // Fallback to first question if option not found
            setCurrentQuestionId(convertedQuestions[0]?.id || "");
          }
        } else {
          setCurrentQuestionId(convertedQuestions[0]?.id || "");
        }
      } else {
        // No demographics provided, start with first question (will show demographic question)
        setCurrentQuestionId(convertedQuestions[0]?.id || "");
      }
      
      setIsLoadingNextTree(false);
     

    } catch (error) {
      console.error(`Error loading tree ${treeIndex}:`, error);
      setIsLoadingNextTree(false);
    }
  };

  // Display current question - EXACT ChatBotSkinCare logic
  useEffect(() => {
    if (!currentQuestion || !hasRun) return;

    setConversationHistory((prevHistory) => {
      if (prevHistory.some((entry) => entry.questionText === currentQuestion.question)) {
        return prevHistory;
      }

      return [
        ...prevHistory,
        {
          questionId: currentQuestion.id,
          questionText: currentQuestion.question,
          options: [],
          chosenOptionId: "",
          questionDate: getCurrentDate(),
          withHeader: !greetingsDone,
          treeId: isMultiMode ? currentTreeInfo?.id : undefined,
          treeName: isMultiMode ? currentTreeInfo?.name : undefined,
        },
      ];
    });

    const awaitingTime = Math.max(100, awaitingTimeForNextMessage(currentQuestion.question));
    const timeout = setTimeout(() => {
      setConversationHistory((prevHistory) =>
        prevHistory.map((entry) =>
          entry.questionId === currentQuestion.id && entry.options.length === 0
            ? { ...entry, options: currentQuestion.options }
            : entry
        )
      );
    }, awaitingTime);

    setGreetingsDone(false);
    return () => clearTimeout(timeout);
  }, [currentQuestionId, greetingsDone, hasRun, currentQuestion]);

  // Auto-scroll
  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [conversationHistory]);

  // Show tree diagnosis message when treeDiagnosisToShow prop changes
  // useEffect(() => {
  //   if (treeDiagnosisToShow) {
  //     const { treeName, diagnosis } = treeDiagnosisToShow;

  //     // Create a styled diagnosis card message
  //     const diagnosisCardData = {
  //       type: 'diagnosis',
  //       treeName,
  //       diagnosis: {
  //         name: diagnosis?.name || 'No diagnosis available',
  //         description: diagnosis?.description || ''
  //       }
  //     };

  //     setConversationHistory(prevHistory => [
  //       ...prevHistory,
  //       {
  //         questionId: `diagnosis_${treeName}_${Date.now()}`,
  //         questionText: JSON.stringify(diagnosisCardData), // Store as JSON for special rendering
  //         options: [],
  //         chosenOptionId: '',
  //         questionDate: getCurrentDate(),
  //         withHeader: true,
  //         treeId: undefined,
  //         treeName: treeName,
  //         isHidden: false,
  //       }
  //     ]);

  //     if (onDiagnosisDisplayed) {
  //       onDiagnosisDisplayed();
  //     }
  //   }
  // }, [treeDiagnosisToShow]);

  // Show final result message when finalResultToShow prop changes
  useEffect(() => {
    if (!finalResultToShow) return;

    const displayFinalResults = async () => {
      const { synthesis, recommendations, diagnoses, deduplicationData } = finalResultToShow;

      // Display synthesis as a structured bilan card (loading dots already showing)
      if (synthesis) {
        // First, remove the loading dots message from conversation history
        setConversationHistory(prevHistory => {
          return prevHistory.filter(item => {
            // Remove loading_dots messages
            try {
              const parsed = JSON.parse(item.questionText);
              return parsed.type !== 'loading_dots';
            } catch {
              return true; // Keep non-JSON messages
            }
          });
        });

        const synthesisCardData = {
          type: 'final_synthesis',
          synthesis,
          diagnoses
        };

        // Show the synthesis card
      
       const synthesisJson = JSON.stringify(synthesisCardData);
       await chatbotCustomRespond("finalSynthesis", [synthesisJson]);
       // Fallback: ensure the synthesis card exists in history
       setConversationHistory(prevHistory => {
         const exists = prevHistory.some(h => h.questionText === synthesisJson);
         if (exists) return prevHistory;
         return [
           ...prevHistory,
           {
             questionId: `final_synthesis_${Date.now()}`,
             questionText: synthesisJson,
             options: [],
             chosenOptionId: '',
             questionDate: getCurrentDate(),
             withHeader: true,
             treeId: undefined,
             treeName: undefined,
             isHidden: false,
           }
         ];
       });
      }

      // Add delay before showing guidance (let users digest the synthesis)
      await new Promise(r => setTimeout(r, 2000));
      
      // Guidance messages after synthesis
      await chatbotCustomRespond("postSynthesisGuide", [
        "Your personalized healing plan is ready.",
        "If you’d like deeper explanations or ongoing support, you can:"
      ]);
      
      // Add delay before download option
      await new Promise(r => setTimeout(r, 1200));

      // Download report message with actionable button
      if (synthesis) {
        const downloadMsg = JSON.stringify({ type: 'download_report', synthesis });
        await chatbotCustomRespond('downloadReport', [downloadMsg]);
      }
      
      // Add delay before products section
      await new Promise(r => setTimeout(r, 1800));

      // Explore products message then recommendations card
      await chatbotCustomRespond("exploreProductsIntro", [
        "Explore recommended products directly in our platform"
      ]);
      
      // Add delay before showing product cards
      await new Promise(r => setTimeout(r, 1200));

      if (recommendations && recommendations.length > 0) {
        const recommendationsCardData = {
          type: 'product_recommendations',
          recommendations,
          deduplicationData
        };
        await chatbotCustomRespond("productRecommendations", [JSON.stringify(recommendationsCardData)]);
      }
      
      // Add delay before teleconsultation
      await new Promise(r => setTimeout(r, 1800));

      // Teleconsultation message, then reveal CTA button
      await chatbotCustomRespond("teleconsultIntro", [
        "Book a teleconsultation with one of our holistic coaches"
      ]);
      await new Promise(r => setTimeout(r, 1200));
      setShowFinalCTA(true);
      
      // Add delay before closing message
      await new Promise(r => setTimeout(r, 1800));

      // Closing message
      await chatbotCustomRespond("closingMessage", [
        "This is more than advice , it’s the beginning of your journey towards balance, confidence, and radiance."
      ]);

      if (onFinalResultDisplayed) {
        onFinalResultDisplayed();
      }
    };

    displayFinalResults();
  }, [finalResultToShow]);
  // Helper functions from ChatBotSkinCare
  const getChosenOptionByQuestionId = async (conversationHistory: ConversationHistoryItem[], questionId: string) => {
    const currentQuestion = conversationHistory.find(c => c.questionId === questionId);
    const currentResponse = currentQuestion?.options?.find(o => o.id === currentQuestion?.chosenOptionId);
    return currentResponse || undefined;
  };

  const isNextQuestionWasAsked = async (conversationHistory: ConversationHistoryItem[], question: Question | undefined) => {
    const questionText = question?.question;
    const isNextQuestionWasExists = conversationHistory.some(c => c.questionText === questionText);
    return isNextQuestionWasExists;
  };

  const getConversationByQuestionText = async (conversationHistory: ConversationHistoryItem[], questionText: String | undefined) => {
    const nextQuestionInConversation = conversationHistory.find(c => c.questionText === questionText);
    return nextQuestionInConversation;
  };

  const determineDiagnosis = async (realConversation: ConversationItem[], conversationHistory: ConversationHistoryItem[]) => {
    const lastQuestionId = realConversation[realConversation.length - 1].questionId;
    const lastChosenOption = await getChosenOptionByQuestionId(conversationHistory, lastQuestionId);
    
    if (finalizeChatbotStep) {
      finalizeChatbotStep(lastQuestionId, lastChosenOption);
    }
    return;
  };

  // Main option click handler - EXACT ChatBotSkinCare logic
  const optionOnClick = async (questionId: string, conversationHistory: ConversationHistoryItem[], chosenOption: Option, index: number) => {
    const chosenOptionId: string = chosenOption.id || "";
    try {
      const isClickedOptionInLastAskedQuestion = conversationHistory[conversationHistory.length - 1].questionId == questionId;
      if (isClickedOptionInLastAskedQuestion) {
        handleUserResponse(questionId, conversationHistory, chosenOption, index);
      } else {
        setConversationHistory(prevHistory => {
          return prevHistory.map((item, index) => {
            if (item.questionId === questionId) {
              return { ...item, chosenOptionId: chosenOptionId };
            }
            return item;
          });
        });
      }
    } catch (error) {
      console.error('Error handling option selection:', error);
    }
  };

  // Handle user response - EXACT ChatBotSkinCare logic
  const handleUserResponse = async (questionId: string, conversationHistory: ConversationHistoryItem[], chosenOption: Option, index: number) => {
    const updatedHistory = conversationHistory.map((item) => {
      if (item.questionId === questionId) {
        return { 
          ...item, 
          chosenOptionId: chosenOption.id,
          treeId: currentTreeInfo?.id,
          treeName: currentTreeInfo?.name
        };
      }
      return item;
    });
    setConversationHistory(updatedHistory);
    
    if (isMultiMode && activeData) {
      await handleMultiTreeResponse(questionId, updatedHistory, chosenOption);
      return;
    }
    
    // Original single-tree logic
    const firstQuestion = activeData?.questions[0];
    if (!firstQuestion) return;
    
    const firstResponse: Option | undefined = await getChosenOptionByQuestionId(updatedHistory, firstQuestion.id);
    let currentResponse = firstResponse;
    let realConversation: ConversationItem[] = [];
    realConversation.push({
      questionId: firstQuestion.id,
      responseId: firstResponse?.id || null,
    });

    while (true) {
      const nextSupposedQuestionId: string = currentResponse?.nextQuestion || "";
      const nextSupposedQuestion: Question | undefined = activeData?.questions.find(q => q.id === nextSupposedQuestionId);
      
      if (!nextSupposedQuestionId) {
        await chatbotCustomRespond("NORESPONSE,CustomEndingRespond", customEndingMessage);
        determineDiagnosis(realConversation, updatedHistory);
        break;
      } else {
        const isNextSupposedQuestionwasAsked: Boolean = await isNextQuestionWasAsked(updatedHistory, nextSupposedQuestion);
        if (isNextSupposedQuestionwasAsked) {
          const nextSupposedQuestionText = nextSupposedQuestion?.question;
          const currentConversation = await getConversationByQuestionText(updatedHistory, nextSupposedQuestionText);
          const chosenOptionInCurrentConversation = currentConversation?.options.find(o => o.id === currentConversation.chosenOptionId);
          const realOption = nextSupposedQuestion?.options.find(o => o.text === chosenOptionInCurrentConversation?.text);
          const realOptionId = realOption?.id;
          const realQuestionId = nextSupposedQuestion?.id;
          
          realConversation.push({
            questionId: realQuestionId || "",
            responseId: realOptionId || "",
          });
          
          currentResponse = realOption;
        } else {
          setCurrentQuestionId(nextSupposedQuestionId);
          realConversation.push({
            questionId: nextSupposedQuestionId,
            responseId: null,
          });
          break;
        }
      }
    }
  };

  // Multi-tree response handler
  const handleMultiTreeResponse = async (questionId: string, updatedHistory: ConversationHistoryItem[], chosenOption: Option) => {
    if (!activeData || !currentTreeInfo) return;

    const firstQuestion = activeData.questions[0];
    const firstResponse: Option | undefined = await getChosenOptionByQuestionId(updatedHistory, firstQuestion.id);
    
    let currentResponse = firstResponse;
    let realConversation: ConversationItem[] = [];
    realConversation.push({
      questionId: firstQuestion.id,
      responseId: firstResponse?.id || null,
    });

    while (true) {
      const nextSupposedQuestionId: string = currentResponse?.nextQuestion || "";
      const nextSupposedQuestion: Question | undefined = activeData.questions.find(q => q.id === nextSupposedQuestionId);
      
      if (!nextSupposedQuestionId) {
        await handleTreeCompletion(updatedHistory, realConversation);
        break;
      } else {
        const isNextSupposedQuestionwasAsked: Boolean = await isNextQuestionWasAsked(updatedHistory, nextSupposedQuestion);
        if (isNextSupposedQuestionwasAsked) {
          const nextSupposedQuestionText = nextSupposedQuestion?.question;
          const currentConversation = await getConversationByQuestionText(updatedHistory, nextSupposedQuestionText);
          const chosenOptionInCurrentConversation = currentConversation?.options.find(o => o.id === currentConversation.chosenOptionId);
          const realOption = nextSupposedQuestion?.options.find(o => o.text === chosenOptionInCurrentConversation?.text);
          const realOptionId = realOption?.id;
          const realQuestionId = nextSupposedQuestion?.id;
          
          realConversation.push({
            questionId: realQuestionId || "",
            responseId: realOptionId || "",
          });
          
          currentResponse = realOption;
        } else {
          setCurrentQuestionId(nextSupposedQuestionId);
          realConversation.push({
            questionId: nextSupposedQuestionId,
            responseId: null,
          });
          break;
        }
      }
    }
  };

  // Handle tree completion
  const handleTreeCompletion = async (treeResponses: ConversationHistoryItem[], realConversation: ConversationItem[]) => {
    try {
      setAllTreeResponses(prev => [...prev, ...treeResponses]);
      setCompletedTreeIndices(prev => new Set([...Array.from(prev), currentTreeIndex]));

      // Removed sending finish messages here to avoid duplication
      // const finishMessages = treeFinishMessages[currentTreeIndex];
      // if (finishMessages) {
      //   await chatbotCustomRespond(`treeFinish_${currentTreeIndex}`, finishMessages);
      // }

      // const completionMessage = [`Great! We've completed the ${currentTreeInfo?.field_name} section.`];
      // await chatbotCustomRespond("treeCompletion", completionMessage);

      if (onTreeComplete && currentTreeInfo) {
        console.log(`📤 Notifying parent: Tree ${currentTreeInfo.id} complete`);
        onTreeComplete(currentTreeInfo.id, treeResponses);
      }

      if (effectiveTreeSequence && currentTreeIndex >= effectiveTreeSequence.trees.length - 1) {
        console.log(`🏁 All trees completed! Current index: ${currentTreeIndex}, Total trees: ${effectiveTreeSequence.trees.length}`);
        
        // Show celebration popup for completing all assessments
        showSectionTransition(
          '✨ Assessment Complete! ✨',
          'Your wellness journey is taking shape',
          '🎉'
        );
        
        // Wait for popup to be visible
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        // Show completion messages while preparing final synthesis
        const completionMessages = [
          "Amazing work! 🌟 You've completed all three assessments.",
          "Now, Healix is analyzing your responses across dermatology, nutrition, and wellbeing.",
          "This holistic analysis will create your personalized wellness plan.",
          "This ensures your plan is accurate, balanced, and truly yours."
        ];
        await chatbotCustomRespond("allTreesCompletion", completionMessages);
        
        // Show loading indicator right after completion messages
        const loadingIndicator = JSON.stringify({ type: 'loading_dots' });
        await chatbotCustomRespond("waitingForSynthesis", [loadingIndicator]);
        
        // Reaching final step forces progress to 100%
        setIsInFinalStep(true);
        // Ensure the latest tree's responses are included when notifying parent
        const combinedResponses = [...allTreeResponses, ...treeResponses];
        if (onAllTreesComplete) {
          onAllTreesComplete(combinedResponses);
        }
      } else {
        console.log(`🔄 More trees to process. Current index: ${currentTreeIndex}, Total trees: ${effectiveTreeSequence?.trees.length || 0}`);
      }
    } catch (error) {
      console.error('Error handling tree completion:', error);
    }
  };

  // Handle all trees completion
  const handleAllTreesComplete = async () => {
    try {
      const finalMessage = [
        "Excellent! We've completed your comprehensive assessment.",
        "Now I'll analyze all your responses to provide you with personalized recommendations."
      ];
      await chatbotCustomRespond("finalCompletion", finalMessage);
    
      // Only call the parent's onAllTreesComplete - avoid duplicate synthesis calls
      if (onAllTreesComplete) {
        onAllTreesComplete(allTreeResponses);
      }
    } catch (error) {
      console.error('Error handling all trees completion:', error);
    }
  };

  // Responsive check
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Scroll to top when screen changes to greeting or welcome
  useEffect(() => {
    if (currentScreen === 'greeting' || currentScreen === 'welcome') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [currentScreen]);

  // Styles
 const mainContainerStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: '100%',
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  gap: isMobile ? '1.875rem' : '4rem',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: isMobile ? '2rem 1.5rem' : '3rem 4rem',
  margin: '0 auto',
};

const textContentStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: isMobile ? 'center' : 'flex-start',
  gap: '1.5rem',
  textAlign: isMobile ? 'center' : 'left',
  order: isMobile ? 2 : 1,
  flex: isMobile ? 'none' : '0 1 45%',
  maxWidth: isMobile ? '100%' : '35rem',
};

const titleStyle: React.CSSProperties = {
  fontFamily: 'Playfair Display, serif',
  fontSize: isMobile ? (window.innerWidth <= 480 ? '2.4rem' : '3rem') : '3.5rem',
  fontWeight: 700,
  color: '#131B5C',
  margin: 0,
  lineHeight: 1.2,
};

const subtitleStyle: React.CSSProperties = {
  fontFamily: 'Lato, sans-serif',
  fontSize: isMobile ? (window.innerWidth <= 480 ? '1.1rem' : '1.25rem') : '1.3rem',
  color: '#131B5C',
  lineHeight: 1.6,
  margin: 0,
  maxWidth: '100%',
};

const buttonStyle: React.CSSProperties = {
  backgroundColor: '#C37559',
  color: 'white',
  border: 'none',
  padding: '1rem 2rem', // 16px 32px / 16
  borderRadius: '3.125rem', // 50px / 16
  fontSize: '1.25rem',
  fontWeight: 600,
  fontFamily: 'Lato, sans-serif',
  cursor: 'pointer',

  transition: 'all 0.3s ease',
  minWidth: '10rem', // 160px / 16
};

const imageContainerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  order: isMobile ? 1 : 2,
  flex: isMobile ? 'none' : '0 1 45%',
  maxWidth: isMobile ? '100%' : '35rem',
};

// const imageStyle: React.CSSProperties = {
//   maxWidth: '100%',
//   height: 'auto',
//   maxHeight: isMobile ? (window.innerWidth <= 480 ? '17.5rem' : '21.875rem') : '25rem', // 280px, 350px, 400px / 16
//   objectFit: 'contain',
// };
const imageStyle: React.CSSProperties = {
  width: '100%',
  height: 'auto',
    maxHeight: isMobile
    ? (window.innerWidth <= 480 ? '22rem' : '28rem') 
    : '40rem', 
  objectFit: 'contain',
  transform: isMobile ? 'scale(1)' : 'scale(1.5)', 
  transformOrigin: 'center center',
  display: 'block',
  margin: '0 auto',
};




  // Timeline progress computation (Assessment, Skin Care, Nutrition, Psychology, Final Result)
  const stages = ['Welcome', 'Skin Care', 'Nutrition', 'Psychology', 'Final Result'];
  const assessmentCompleted = hasRun && demographicsCompleted;
  const treesCompletedCount = completedTreeIndices.size; // 0..3
  const baseStagesBeforeFinal = stages.length - 1; // 4
  const completedBeforeFinal = Math.min(baseStagesBeforeFinal, (assessmentCompleted ? 1 : 0) + treesCompletedCount);
  const completedStagesCount = isInFinalStep ? stages.length : completedBeforeFinal;
  const activeStageIndex = isInFinalStep
    ? stages.length - 1
    : (!assessmentCompleted
        ? 0
        : (isMultiMode
            ? Math.min(1 + Math.max(0, currentTreeIndex), baseStagesBeforeFinal - 1)
            : 0));
  const timelineFillWidth = isInFinalStep ? 100 : (completedBeforeFinal / stages.length) * 100; // max 80% before final
  const currentStageName = isInFinalStep ? 'Final Result' : stages[activeStageIndex] || 'Assessment';

  const greetingContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: '20px',
    padding: 0,
    maxWidth: '100%',
    width: '100%',
  };

  const greetingTitleStyle: React.CSSProperties = {
    fontFamily: 'Playfair Display, serif',
    fontSize: isMobile ? (window.innerWidth <= 480 ? '2rem' : '2.4rem') : '2.5rem',
    fontWeight: 700,
    color: '#131B5C',
    margin: 0,
    lineHeight: 1.3,
  };

  const greetingSubtitleStyle: React.CSSProperties = {
    fontFamily: 'Lato, sans-serif',
    fontSize: isMobile ? (window.innerWidth <= 480 ? '1.2rem' : '1.3rem') : '1.2rem',
    color: '#131B5C',
    lineHeight: 1.6,
    margin: 0,
  };

const greetingImageStyle: React.CSSProperties = {
  maxWidth: '100%',
  maxHeight: isMobile ? '11.25rem' : '11.25rem', // 180px -> 11.25rem
  objectFit: 'contain',
  margin: '0 auto', // center horizontally
  display: 'block',
};


  // Show demographics selector FIRST if needed (bypass currentQuestion check)
  if (showDemographics && !demographicsCompleted && currentScreen === 'conversation') {
    console.log('🎯 Showing demographics selector (no question needed yet)');
    // Demographics selector will be rendered in the main return statement
    // Skip the currentQuestion validation in this case
  } else if (!currentQuestion && currentScreen === 'conversation' && hasRun) {
    // Stay inside the chat interface even when loading
    // No loading screen - questions will appear when ready
  }

  return  (
    <>
      <style>{`
        /* ---------- General Styles (Desktop stays unchanged) ---------- */
.healix-modal-backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; z-index: 20000; } 
.healix-modal-content { width: 95%; max-width: 1000px; max-height: 90vh; overflow: auto; background: #fff; border-radius: 16px; position: relative; }
 .healix-modal-close { position: absolute; top: 8px; right: 8px; background: transparent; border: none; color: #131B5C; font-size: 24px; cursor: pointer; width: 40px; height: 40px; border-radius: 50%; }
  .healix-overlay { position: static; background: #FAF8F5; display: flex; align-items: center; justify-content: center; padding: 0; width: 100%; min-height: auto; }
   .healix-close-btn { position: fixed; top: 20px; right: 20px; background: rgba(255, 255, 255, 0.95); border: none; font-size: 24px; color: #131B5C; cursor: pointer; width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; z-index: 10000; transition: all 0.3s ease; box-shadow: 0 2px 8px rgba(0,0,0,0.15); } 
.healix-close-btn:hover { transform: scale(1.05) rotate(90deg); background-color: rgba(255, 255, 255, 1); box-shadow: 0 4px 12px rgba(0,0,0,0.2); }
.conversation-container {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0;
}

.restart-section {
  display: flex;
  align-items: center;
  margin-right: auto;
}

.restart-btn {
  background: transparent;
  border: none;
  color: #131B5C;
  font-size: 0.85rem;
  cursor: pointer;
  font-family: 'Lato', sans-serif;
  padding: 0;
  border-radius: 0;
  transition: opacity 0.2s ease;
  font-weight: 400;
  box-shadow: none;
  text-decoration: none;
  text-transform: none;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.restart-btn:hover {
  opacity: 0.7;
}

.chat-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: auto;
  width: 100%;
  max-width: 100%;
  background: #F4F2EE;
  border-radius: 24px;
  overflow: visible;
  margin: 0;
  padding: 0;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-top: none;
  border-bottom: none;
 
}

.chat-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 90% 90%, rgba(195, 117, 89, 0.08), transparent 50%),
              radial-gradient(circle at 10% 10%, rgba(113, 123, 97, 0.05), transparent 50%);
  pointer-events: none;
  opacity: 0;
  animation: ambientGlow 4s ease-in-out infinite;
  z-index: 0;
}

.chat-container > * {
  position: relative;
  z-index: 1;
}

@keyframes ambientGlow {
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

.progress-section {
  padding: 1.5rem 2.5rem;
  padding-top: 2rem;
  border-bottom: none;
  flex-shrink: 0;
  margin-bottom: 0;
  background: #F4F2EE;
  border-radius: 24px 24px 0 0;
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
}

.step-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 0.5rem;
}

.step-percentage {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  color: #131B5C;
  font-weight: 700;
  background: linear-gradient(135deg, rgba(113, 123, 97, 0.12), rgba(195, 117, 89, 0.08));
  padding: 0.4rem 1rem;
  border-radius: 16px;
  letter-spacing: 0.3px;
}

.progress-bar {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 0.5rem;
  height: 8px;
  background: linear-gradient(90deg, rgba(229, 227, 224, 0.5), rgba(240, 240, 240, 0.7));
  border-radius: 12px;
  overflow: hidden;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #717B61, #8A9472, #717B61);
  background-size: 200% 100%;
  border-radius: 12px;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  box-shadow: 0 2px 6px rgba(113, 123, 97, 0.3);
  animation: shimmer 2.5s ease-in-out infinite;
}

.progress-fill::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: slide 2s ease-in-out infinite;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.2), transparent);
  border-radius: 12px 12px 0 0;
}

@keyframes shimmer {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes slide {
  0% {
    left: -100%;
  }
  100% {
    left: 200%;
  }
}

/* Timeline */
.timeline {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.timeline-track {
  position: relative;
  flex: 1;
  height: 0.5rem;
  background: linear-gradient(90deg, rgba(229, 227, 224, 0.5), rgba(240, 240, 240, 0.7));
  border-radius: 12px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);
}

.timeline-fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(90deg, #717B61, #8A9472, #717B61);
  background-size: 200% 100%;
  border-radius: 12px;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(113, 123, 97, 0.25);
  animation: shimmer 2.5s ease-in-out infinite;
}

.timeline-markers {
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
}

.timeline-dot {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: rgba(200, 200, 200, 0.6);
  border: 2px solid white;
  transition: all 0.3s ease;
}

.timeline-dot.completed {
  background: linear-gradient(135deg, #717B61, #8B9A6B);
}

.timeline-dot.active {
  background: linear-gradient(135deg, #C37559, #D68970);
  transform: scale(1.1);
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-family: 'Lato', sans-serif;
  padding: 2rem;
  margin-bottom: 2rem;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.message-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.bot-message,
.user-message {
  display: flex;
  align-items: flex-start;
  gap: 0.875rem;
  max-width: 100%;
  animation: messageSlideIn 0.3s ease-out;
}

@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bot-message .message-text,
.user-message .message-text {
  padding: 1.125rem 1.75rem;
  border-radius: 18px;
  word-wrap: break-word;
  max-width: 75%;
  line-height: 1.35;
  font-size: 1.125rem;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
 
}

.bot-message .message-text {
  background: #F0F0F0;
  color: #131B5C;
  border-bottom-left-radius: 4px;
}

.user-message {
  flex-direction: row-reverse;
}

.user-message .message-text {
  background: #C37559;
  color: white;
  align-self: flex-end;
  border-bottom-right-radius: 4px;
}

.bot-avatar {
  width: 2.75rem;
  height: 2.75rem;
  object-fit: contain;
  flex-shrink: 0;
}

.user-avatar {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: none;
}

/* Options styling - RIGHT FLOAT on all screens */
.options-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.875rem;
  align-items: center;
  margin-top: 1.25rem;
  justify-content: flex-end;
}

.options-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.875rem;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

.option-btn {
  background: #F4F2EE;
  color: #131B5C;
  border: 1px solid rgba(19, 27, 92, 0.15);
  padding: 0.875rem 1.75rem;
  border-radius: 30px;
  font-size: 1.0625rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  margin-right: 0;
}

.option-btn:hover {
  border-color: #C37559;
  transform: translateY(-2px);
  background: #F4F2EE;
}

.option-btn.selected {
  background: #C37559;
  color: white;
  border-color: #C37559;
}

/* -------------------- MOBILE / TABLET ENHANCEMENTS -------------------- */
@media (max-width: 1024px) {
  .chat-container {
    min-height: 100vh;
    padding: 0;
  }

  .progress-section {
    padding: 1rem 1.5rem;
  }

  .step-info {
    padding: 0 1rem;
  }

  .progress-bar {
    padding: 0 1rem;
  }

  .chat-messages {
    gap: 0.5rem;
    padding: 1.5rem 1.25rem 2rem;
  }

  .message-group {
    gap: 0.5rem;
  }

  .bot-message .message-text,
  .user-message .message-text {
    max-width: 80%;
    font-size: 1rem;
    padding: 0.875rem 1.25rem;
    line-height: 1.3;
  }

  .bot-avatar {
    width: 2.25rem;
    height: 2.25rem;
  }

  .user-avatar {
    width: 2.25rem;
    height: 2.25rem;
  }

  .option-btn {
    font-size: 0.95rem;
    padding: 0.625rem 1.25rem;
  }
}

@media (max-width: 768px) {
  .chat-container {
    min-height: 100vh;
    padding: 0;
  }

  .progress-section {
    padding: 0.875rem 1rem;
  }

  .step-info {
    padding: 0 0.75rem;
  }

  .progress-bar {
    padding: 0 0.75rem;
  }

  .chat-messages {
    gap: 0.5rem;
    padding: 1.25rem 1rem 1.5rem;
  }

  .message-group {
    gap: 0.5rem;
  }

  .bot-message .message-text,
  .user-message .message-text {
    max-width: 85%;
    font-size: 0.9375rem;
    padding: 0.75rem 1rem;
    line-height: 1.3;
  }

  .bot-avatar {
    width: 2rem;
    height: 2rem;
  }

  .user-avatar {
    width: 2rem;
    height: 2rem;
  }

  .option-btn {
    font-size: 0.9rem;
    padding: 0.625rem 1rem;
  }

  .healix-close-btn,
  .restart-btn {
    display: none;
  }

  .step-name {
    font-size: 0.85rem;
  }

  .step-percentage {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
}


@media (max-width: 480px) {
  .chat-container {
    min-height: 100vh;
    padding: 0;
  }

  .progress-section {
    padding: 0.75rem 0.875rem;
  }

  .step-info {
    padding: 0 0.5rem;
  }

  .progress-bar {
    padding: 0 0.5rem;
  }

  .chat-messages {
    gap: 0.5rem;
    padding: 1rem 0.875rem 1.25rem;
  }

  .bot-message .message-text,
  .user-message .message-text {
    font-size: 0.9rem;
    padding: 0.625rem 0.875rem;
    line-height: 1.3;
    max-width: 88%;
  }

  .message-group {
    gap: 0.4rem;
  }

  .bot-avatar,
  .user-avatar {
    width: 1.875rem;
    height: 1.875rem;
  }

  .option-btn {
    font-size: 0.875rem;
    padding: 0.5rem 0.875rem;
  }

  .bot-avatar {
    width: 2.2rem;
    height: 2.2rem;
  }

  .user-avatar {
    width: 1.8rem;
    height: 1.8rem;
  }
}

@media (min-width: 1024px) {
  span { font-family: 'Lato', sans-serif; font-size: 20px !important; font-weight: 500 !important; }
}
  @media (max-width: 1024px) {
  span {font-weight: 500 !important; }
}

/* Section Transition Popup */
.section-transition-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  padding: 1.5rem;
  animation: fadeIn 0.4s ease-out forwards;
}

  .section-transition-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 550px;
    width: 100%;
    position: relative;
  }
  
  .section-transition-healix-image {
    width: 330px;
    height: auto;
    object-fit: contain;
    flex-shrink: 0;
    position: absolute;
    top: -85px;
    left: -155px;
    z-index: 2;
  }.section-transition-content {
  background: #F4F2EE;
  border-radius: 24px;
  padding: 2.5rem 2.5rem;
  text-align: center;
  width: 100%;
  box-shadow: 
    0 8px 32px rgba(19, 27, 92, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(19, 27, 92, 0.08);
  position: relative;
  overflow: visible;
  z-index: 1;
}

.section-transition-content > * {
  position: relative;
  z-index: 1;
}

.section-transition-icon {
  font-size: 0;
  margin: 0;
  display: none;
}

.section-transition-title {
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  font-weight: 700;
  color: #131B5C;
  margin: 0 0 1rem 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.section-transition-subtitle {
  font-family: 'Lato', sans-serif;
  font-size: 1.1rem;
  font-weight: 500;
  color: #C37559;
  margin: 0;
  line-height: 1.6;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes popIn {
  0% {
    opacity: 0;
    transform: scale(0.92) translateY(20px);
  }
  60% {
    opacity: 1;
    transform: scale(1.02) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes ambientGlow {
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@media (max-width: 1024px) {
  .section-transition-wrapper {
    max-width: 500px;
  }

  .section-transition-healix-image {
    width: 290px;
    top: -72px;
    left: -122px;
  }

  .section-transition-content {
    padding: 2.25rem 2.25rem;
  }
  
  .section-transition-title {
    font-size: 1.875rem;
  }
  
  .section-transition-subtitle {
    font-size: 1.05rem;
  }
}

@media (max-width: 768px) {
  .section-transition-overlay {
    padding: 1.25rem;
  }

  .section-transition-wrapper {
    max-width: 90%;
  }

  .section-transition-healix-image {
    width: 250px;
    top: -60px;
    left: -105px;
  }

  .section-transition-content {
    padding: 2rem 2rem 2.5rem 2rem;
  }
  
  .section-transition-title {
    font-size: 1.75rem;
    margin-bottom: 0.875rem;
  }
  
  .section-transition-subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .section-transition-overlay {
    padding: 1rem;
  }

  .section-transition-wrapper {
    max-width: 92%;
  }

  .section-transition-healix-image {
    width: 210px;
    top: -55px;
    left: -88px;
  }

  .section-transition-content {
    padding: 1.75rem 1.75rem 2rem 1.75rem;
    border-radius: 20px;
  }
  
  .section-transition-title {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
  }
  
  .section-transition-subtitle {
    font-size: 0.95rem;
  }
}

@media (max-width: 360px) {
  .section-transition-healix-image {
    width: 185px;
    top: -48px;
    left: -77px;
  }
  
  .section-transition-content {
    padding: 1.5rem 1.5rem 1.75rem 1.5rem;
    border-radius: 18px;
  }
  
  .section-transition-title {
    font-size: 1.35rem;
  }
  
  .section-transition-subtitle {
    font-size: 0.9rem;
  }
}

/* Floating Healix Animation */
.floating-healix-container {
  position: fixed;
  bottom: -50px;
  right: -50px;
  width: 280px;
  height: 280px;
  z-index: 1000;
  pointer-events: none;
}

.floating-healix-container:hover {
  /* No hover effect */
}

.floating-healix-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@keyframes floatUpDown {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
}

@keyframes gentleFloat {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-8px) rotate(2deg);
  }
}

@keyframes waveHand {
  0%, 100% {
    transform: rotate(0deg);
  }
  20%, 60% {
    transform: rotate(-15deg);
  }
  40%, 80% {
    transform: rotate(15deg);
  }
}

@keyframes excitedBounce {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  25% {
    transform: scale(1.15) rotate(-5deg);
  }
  75% {
    transform: scale(1.15) rotate(5deg);
  }
}

@keyframes thinkingPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

@keyframes encourageGlow {
  0%, 100% {
    transform: scale(1);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.08);
    filter: brightness(1.2);
  }
}

@keyframes celebrateSpin {
  0% {
    transform: rotate(0deg) scale(1);
  }
  25% {
    transform: rotate(10deg) scale(1.1);
  }
  50% {
    transform: rotate(0deg) scale(1.15);
  }
  75% {
    transform: rotate(-10deg) scale(1.1);
  }
  100% {
    transform: rotate(0deg) scale(1);
  }
}

/* Speech bubble tooltip - INSIDE the image */
.healix-tooltip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(135deg, rgba(244, 242, 238, 0.98), rgba(255, 255, 255, 0.95));
  color: #131B5C;
  padding: 12px 18px;
  border-radius: 20px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 700;
  white-space: normal;
  box-shadow: 0 6px 20px rgba(195, 117, 89, 0.4);
  opacity: 0;
  animation: fadeInTooltip 0.5s ease forwards;
  z-index: 1001;
  border: 3px solid #C37559;
  text-align: center;
  max-width: 180px;
  line-height: 1.5;
  backdrop-filter: blur(8px);
}

@keyframes fadeInTooltip {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

/* Particle effects */
.healix-particles {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
}

.particle {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #C37559, #717B61);
  opacity: 0;
  animation: particleFloat 1s ease-out forwards;
}

.particle:nth-child(1) {
  top: 50%;
  left: 50%;
  animation-delay: 0s;
  transform: translate(-50%, -50%) rotate(0deg) translateY(-40px);
}

.particle:nth-child(2) {
  top: 50%;
  left: 50%;
  animation-delay: 0.1s;
  transform: translate(-50%, -50%) rotate(60deg) translateY(-40px);
}

.particle:nth-child(3) {
  top: 50%;
  left: 50%;
  animation-delay: 0.2s;
  transform: translate(-50%, -50%) rotate(120deg) translateY(-40px);
}

.particle:nth-child(4) {
  top: 50%;
  left: 50%;
  animation-delay: 0.3s;
  transform: translate(-50%, -50%) rotate(180deg) translateY(-40px);
}

.particle:nth-child(5) {
  top: 50%;
  left: 50%;
  animation-delay: 0.4s;
  transform: translate(-50%, -50%) rotate(240deg) translateY(-40px);
}

.particle:nth-child(6) {
  top: 50%;
  left: 50%;
  animation-delay: 0.5s;
  transform: translate(-50%, -50%) rotate(300deg) translateY(-40px);
}

@keyframes particleFloat {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1.2);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
  }
}

/* Glow effect when active */
.floating-healix-container.active {
 
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .floating-healix-container {
    width: 180px;
    height: 180px;
    bottom: -50px;
    right: -50px;
  }
  
  .healix-overlay {
    min-height: auto !important;
    height: auto !important;
  }
}

@media (max-width: 1024px) {
  .healix-overlay {
    min-height: auto !important;
    height: auto !important;
  }
}
`}</style>

      <AnimatePresence mode="wait">
        
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="healix-overlay"
          >

            {/* Popup removed: conversation starts inline */}

            {/* Loading screen for diagnosis */}
            {isLoadingDiagnosisVisible && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  
                  zIndex: 10000,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '50px',
                  px: 3,
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontFamily: 'Lato , sans-serif',
                      fontWeight: 400,
                      fontSize: '25px',
                      color: '#FFFFFF',
                      mb: 3,
                    }}
                  >
                    Skin Diagnosis Report
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontWeight: 'bold',
                      fontSize: '40px',
                      color: '#FFFFFF',
                      lineHeight: '60px',
                    }}
                  >
                    Processing Diagnosis Result
                  </Typography>
                </Box>

                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                  <CircularProgress
                    variant="determinate"
                    value={100}
                    size={173}
                    thickness={8}
                    sx={{
                      color: 'rgba(255, 255, 255, 0.2)',
                      position: 'absolute',
                      left: 0,
                      top: '20px'
                    }}
                  />
                  <CircularProgress
                    size={173}
                    variant="indeterminate"
                    thickness={8}
                    sx={{
                      color: '#FFFFFF',
                      top: '20px',
                      position: 'relative'
                    }}
                  />
                </Box>
              </Box>
            )}
{/* Loading next tree */}
{isLoadingNextTree && (
  <Box
    sx={{
      position: 'absolute',
      top: '20px',
      right: '20px',          // small popup on the side
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 12px',
      background: 'rgba(113, 123, 97, 0.9)',
      borderRadius: '8px',
  
      zIndex: 1200,
      color: '#fff',
      fontFamily: 'Lato, sans-serif',
    }}
  >
    <CircularProgress size={18} sx={{ color: '#fff' }} />
    <Typography sx={{ fontSize: '0.85rem' }}>
      Loading next section...
    </Typography>
  </Box>
)}



            {/* Main content */}
            {currentScreen === 'welcome' ? (
              <motion.div style={mainContainerStyle}>
                <motion.div style={textContentStyle}>
                  <motion.h1 
                    style={titleStyle}
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                  >
                    Hello!<br />I'm Healix
                  </motion.h1>

                  <motion.p 
                    style={subtitleStyle}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                  >
I’m not just a chatbot, I’m your friendly companion for skin, nutrition, and mental well-being.
You can talk to me anytime. I’ll listen, ask the right questions, and gently guide you with advice that fits your needs.
Together, we’ll find simple, safe ways to care for your health, your beauty, and your peace of mind.
                  </motion.p>
                  <motion.p 
                            style={{ 
    ...subtitleStyle, 
    fontWeight: 600 
  }}
       
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                  >
                   Let’s begin this journey, one step at a time.
                  </motion.p>

                  <motion.button
                    whileHover={{ scale: 1.05, y: -3 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={handleSubscribeClick}
                    style={buttonStyle}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.6 }}
                  >
                    Subscribe
                  </motion.button>
                </motion.div>

                <motion.div
                  style={imageContainerStyle}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 0.1 }}
                >
                  <img src={healixImage} alt="Healix Character" style={imageStyle} />
                </motion.div>
              </motion.div>
            ) : currentScreen === 'greeting' ? (
              <motion.div
                style={greetingContainerStyle}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                >
                  <img src={healixGreetingImage} alt="Healix Character" style={greetingImageStyle} />
                </motion.div>

                <motion.div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <motion.h1 
                    style={greetingTitleStyle}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.5 }}
                  >
                    Hi {userName}!<br />How are you feeling today?
                  </motion.h1>

                  <motion.p 
                    style={greetingSubtitleStyle}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.7 }}
                  >
                    Ups and downs are normal, you don’t have to face them alone.
                    Share your skin, routines, and mood, and I’ll guide you with care toward solutions
                     that fit you.
                  </motion.p>

                  <motion.p 
                     style={{ 
    ...greetingSubtitleStyle, 
    fontWeight: 600 
  }}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.9 }}
                  >
                    Your well-being matters, and I’m here to support you at every step.
                  </motion.p>
                </motion.div>

                <motion.button
                  initial={{ opacity: 0, y: 50, scale: 0.8 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  transition={{ duration: 0.6, delay: 1.1 }}
                  whileHover={{ scale: 1.05, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleStartConversation}
                  style={buttonStyle}
                >
                  Start Conversation
                </motion.button>
              </motion.div>
            ) : (
              <motion.div className="conversation-container">
                {/* Chat Container */}
                <motion.div
                  className="chat-container"
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                >
                  {/* Progress Section */}
                  <motion.div 
                    className="progress-section"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                  >
                    <div className="step-info">
                      <motion.div 
                        className="restart-section"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                      >
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          className="restart-btn"
                          onClick={() => {
                            setCurrentScreen('greeting');
                            setConversationStarted(false);
                            setHasRun(false);
                            setConversationHistory([]);
                            setCurrentQuestionId("");
                            setAllTreeResponses([]);
                            setCurrentTreeIndex(0);
                            setCurrentTreeData(null);
                            setShowDemographics(multiTreeMode && !demographicsOptions);
                            setSelectedAge('');
                            setSelectedGender('');
                            setDemographicsCompleted(!multiTreeMode || !!demographicsOptions);
                          }}
                        >
                          ↻ Restart Conversation
                        </motion.button>
                      </motion.div>
                      <div className="step-percentage">{Math.round(timelineFillWidth)}%</div>
                    </div>
                    <div className="timeline">
                      <div className="timeline-track">
                        <div
                          className="timeline-fill"
                          style={{ width: `${timelineFillWidth}%` }}
                        />
                        <div className="timeline-markers">
                          {stages.map((_, idx) => {
                            const isCompleted = isInFinalStep ? true : idx < completedStagesCount;
                            const isActive = (!isInFinalStep && idx === activeStageIndex) || (isInFinalStep && idx === stages.length - 1);
                            const className = `timeline-dot${isCompleted ? ' completed' : ''}${isActive ? ' active' : ''}`;
                            return <span key={idx} className={className} />;
                          })}
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                      {stages.map((label, idx) => (
                        <span
                          key={idx}
                          style={{ fontSize: '0.8rem', color: idx === stages.length - 1 && isInFinalStep ? '#C37559' : '#131B5C', fontWeight: 700 }}
                        >
                          {idx === stages.length - 1 && isInFinalStep ? '✨ Your Journey Complete' : label}
                        </span>
                      ))}
                    </div>
                  </motion.div>

                  {/* Chat Messages */}
                  <div className="chat-messages" ref={chatWindowRef}>
                    {/* Demographics Question */}
                    {showDemographics && (
                      <motion.div
                        className="message-group"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                      >
                        <div className="bot-message" style={{ fontFamily: 'Lato, sans-serif' }}>
  <img src={botChatImage} alt="Healix" className="bot-avatar" />
  <TypewriterMessage 
      text="Hi, I'm Healix! To give you the most personalized health assessment, could you please share your age and gender with me?" 
      keyWordDelay={37} 
  />
</div>


                        <div className="options-container">
                          <div style={{ marginBottom: '10px', fontSize: '14px', color: '#666', textAlign: 'left', width: '100%', fontFamily: 'Lato, sans-serif' }}>
                            Your Age:
                          </div>
                          <input
                            type="number"
                            min="10"
                            max="120"
                            placeholder="Enter your age (e.g., 25)"
                            value={numericAge}
                            onChange={(e) => setNumericAge(e.target.value)}
                            style={{
                              width: '100%',
                              padding: '12px',
                              fontSize: '16px',
                              borderRadius: '8px',
                              border: '1px solid #E0E0E0',
                              marginBottom: '15px',
                              fontFamily: 'Lato, sans-serif',
                              boxSizing: 'border-box'
                            }}
                          />

                          <div style={{ marginBottom: '10px', fontSize: '14px', color: '#666', textAlign: 'left', width: '100%', marginTop: '15px', fontFamily: 'Lato, sans-serif' }}>
                            Gender:
                          </div>
                          <div className="options-grid">
                            {['male', 'female'].map((gender) => (
                              <button
                                key={gender}
                                className={`option-btn ${selectedGender === gender ? 'selected' : ''}`}
                                onClick={() => {
                                  setSelectedGender(gender);
                                  setUserGender(gender); // Save gender for avatar icon
                                  // Auto-submit when both are selected
                                  const age = parseInt(numericAge);
                                  if (numericAge && age >= 10 && age <= 120 && onDemographicsSubmit) {
                                    setTimeout(() => {
                                      const ageRange = mapAgeToRange(age);
                                      onDemographicsSubmit(ageRange, gender, age);
                                      setShowDemographics(false);
                                      setDemographicsCompleted(true);
                                    }, 500);
                                  }
                                }}
                              >
                                {gender.charAt(0).toUpperCase() + gender.slice(1)}
                              </button>
                            ))}
                          </div>
                        </div>
                      </motion.div>
                    )}

                    {/* Conversation History - match ChatBotSkinCare logic while keeping Healix styles */}
                    {demographicsCompleted && conversationHistory
                      .filter(item => !item.isHidden)
                      .map((item, index) => (
                        item.withHeader ? (
                          <motion.div
                            key={index}
                            className="message-group"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                          >
                            {/* QUESTION WITH HEADER (avatar + date) */}
                            <div className="bot-message">
                              <img src={botChatImage} alt="Healix" className="bot-avatar" />
                              <div>
                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px', fontFamily: 'Lato, sans-serif' }}>{item.questionDate}</div>
                                {isSpecialMessage(item.questionText) ? (
                                  <div className="special-message-container">
                                    {renderSpecialMessage(item.questionText)}
                                  </div>
                                ) : (
                                  <TypewriterMessage text={item.questionText} keyWordDelay={10} />
                                )}
                              </div>
                            </div>

                            {/* OPTIONS (always visible to allow reselection) */}
                            {Array.isArray(item.options) && item.options.length > 0 && (
                              <div className="options-container">
                                <div className="options-grid">
                                  {item.options.map((option) => (
                                    <button
                                      key={option.id}
                                      className={`option-btn ${item.chosenOptionId === option.id ? 'selected' : ''}`}
                                      onClick={(e) => {
                                        (e.currentTarget as HTMLButtonElement).blur();
                                        optionOnClick(item.questionId, conversationHistory, option, index);
                                      }}
                                    >
                                      {option.text}
                                    </button>
                                  ))}
                                </div>
                                {userAvatar ? (
                                  <img
                                    src={userAvatar}
                                    alt="User"
                                    className="user-avatar"
                                  />
                                ) : (
                                  <Avatar
                                    className="user-avatar"
                                    sx={{
                                      bgcolor: '#6B6B6B',
                                      width: 40,
                                      height: 40,
                                      fontSize: '1rem',
                                      fontWeight: 600,
                                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
                                    }}
                                  >
                                    {userGender === 'female' ? (
                                      <Person3 sx={{ fontSize: '1.85rem', color: '#fff', fontWeight: 600 }} />
                                    ) : userGender === 'male' ? (
                                      <AccountCircle sx={{ fontSize: '1.75rem', color: '#fff', fontWeight: 500 }} />
                                    ) : (
                                      userName ? userName.charAt(0).toUpperCase() : 'U'
                                    )}
                                  </Avatar>
                                )}
                              </div>
                            )}
                          </motion.div>
                        ) : (
                          <motion.div
                            key={index}
                            className="message-group"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                          >
                            {/* QUESTION WITHOUT HEADER (no avatar, indented) */}
                            <div className="bot-message" style={{ paddingLeft: '65px' }}>
                              {isSpecialMessage(item.questionText) ? (
                                <div className="special-message-container">
                                  {renderSpecialMessage(item.questionText)}
                                </div>
                              ) : (
                                <TypewriterMessage text={item.questionText} keyWordDelay={15} />
                              )}
                            </div>

                            {/* OPTIONS (always visible to allow reselection) */}
                            {Array.isArray(item.options) && item.options.length > 0 && (
                              <div className="options-container">
                                <div className="options-grid">
                                  {item.options.map((option) => (
                                    <button
                                      key={option.id}
                                      className={`option-btn ${item.chosenOptionId === option.id ? 'selected' : ''}`}
                                      onClick={() => optionOnClick(item.questionId, conversationHistory, option, index)}
                                    >
                                      {option.text}
                                    </button>
                                  ))}
                                </div>
                                {userAvatar ? (
                                  <img
                                    src={userAvatar}
                                    alt="User"
                                    className="user-avatar"
                                  />
                                ) : (
                                  <Avatar
                                    className="user-avatar"
                                    sx={{
                                      bgcolor: '#6B6B6B',
                                      width: 40,
                                      height: 40,
                                      fontSize: '1rem',
                                      fontWeight: 600,
                                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
                                    }}
                                  >
                                    {userGender === 'female' ? (
                                      <Person3 sx={{ fontSize: '1.85rem', color: '#fff', fontWeight: 600 }} />
                                    ) : userGender === 'male' ? (
                                      <AccountCircle sx={{ fontSize: '1.75rem', color: '#fff', fontWeight: 500 }} />
                                    ) : (
                                      userName ? userName.charAt(0).toUpperCase() : 'U'
                                    )}
                                  </Avatar>
                                )}
                              </div>
                            )}
                          </motion.div>
                        )
                      ))}
                    {/* Final Button after completion (revealed after staged sequence) */}
                    {showFinalCTA && (
                      <motion.div
                        className="message-group"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                      >
                        <div className="bot-message" style={{ paddingLeft: '65px' }}>
                          <div>
                            <p style={{
                              fontFamily: 'Lato, sans-serif',
                              fontSize: '16px',
                              color: '#717B61',
                              marginBottom: '12px',
                            }}>
                              If you need more details and you want to describe more your needs, book an appointment with our doctors anytime you want!
                            </p>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: '#C37559',
                                color: 'white',
                                padding: '12px 24px',
                                borderRadius: '25px',
                                fontSize: '16px',
                                fontWeight: 600,
                                fontFamily: 'Lato, sans-serif',
                                '&:hover': {
                                  backgroundColor: '#A65A47',
                                },
                              }}
                              onClick={() => navigate('/teleconsultation')}
                            >
                              Book a Session
                            </Button>
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </div>
                </motion.div>
              </motion.div>
            )}
            
            {/* Section Transition Popup */}
            {showTransitionPopup && transitionSection && (
              <motion.div
                className="section-transition-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setShowTransitionPopup(false)}
              >
                <motion.div
                  className="section-transition-wrapper"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.4, ease: [0.34, 1.56, 0.64, 1] }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <motion.img 
                    src={healixImage} 
                    alt="Healix"
                    className="section-transition-healix-image"
                    initial={{ x: -50, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  />
                  <div className="section-transition-content">
                    <div className="section-transition-icon">{transitionSection.icon}</div>
                    <h2 className="section-transition-title">{transitionSection.title}</h2>
                    <p className="section-transition-subtitle">{transitionSection.subtitle}</p>
                  </div>
                </motion.div>
              </motion.div>
            )}
            
            {/* Floating Healix - Static */}
            {currentScreen === 'conversation' && showFloatingHealix && (
              <div
                ref={floatingHealixRef}
                className="floating-healix-container"
              >
                <img 
                  src={healixImage} 
                  alt="Healix Assistant" 
                  className="floating-healix-image"
                />
              </div>
            )}
          </motion.div>
      </AnimatePresence>
    </>
  );
};

export default HealixBot;